module.exports = __webpack_public_path__ + "img/page11.a043ee03.png";